import React from 'react';
import { WhatsAppButtonDesktop, WhatsAppButtonMobile } from './styles';
import { socialNetworks } from '../../data/contact-info';
import {  useTranslation } from 'next-i18next';

const WhatsAppButton = () => {
  const { t } = useTranslation();
  return (
    <>
      <WhatsAppButtonDesktop href={socialNetworks.whatsapp()} target="_blank" rel="noopener noreferrer">
        <span>
          {t("footer.startChat")}
        </span>
        <img src="/blog/assets/icons/whatsapp-white.svg" alt="WhatsApp" />
      </WhatsAppButtonDesktop>

      <WhatsAppButtonMobile href={socialNetworks.whatsapp()} target="_blank" rel="noopener noreferrer">
        <img src="/blog/assets/icons/whatsapp-white.svg" alt="WhatsApp" />
      </WhatsAppButtonMobile>
    </>
  );
};

export default WhatsAppButton; 